import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function TermsOfService() {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <Link to="/login" className="legal-back">
          ← חזרה להתחברות
        </Link>

        <h1>תנאי שימוש</h1>
        <p className="legal-updated">עודכן לאחרונה: דצמבר 2024</p>

        <section>
          <h2>1. הסכמה לתנאים</h2>
          <p>
            ברוכים הבאים לכתב כמויות. בעצם הגישה או השימוש בשירות שלנו, אתה מסכים להיות מחויב לתנאי
            שימוש אלה. אם אינך מסכים לתנאים אלה, אנא הימנע משימוש בשירות.
          </p>
        </section>

        <section>
          <h2>2. תיאור השירות</h2>
          <p>
            כתב כמויות הוא פלטפורמה לניהול פרויקטי בנייה ושיפוץ. השירות מאפשר למשתמשים לנהל תקציבים,
            לעקוב אחר התקדמות, ליצור כתבי כמויות ולתקשר עם ספקים וקבלנים.
          </p>
        </section>

        <section>
          <h2>3. הרשמה וחשבון משתמש</h2>
          <p>
            כדי להשתמש בשירות, עליך ליצור חשבון ולספק מידע מדויק ועדכני. אתה אחראי לשמירה על סודיות
            פרטי החשבון שלך ולכל הפעילות המתרחשת תחת החשבון שלך.
          </p>
          <ul>
            <li>עליך להיות בן 18 ומעלה כדי להשתמש בשירות</li>
            <li>אתה אחראי לשמירה על סיסמה חזקה ומאובטחת</li>
            <li>עליך להודיע לנו מיד על כל שימוש לא מורשה בחשבונך</li>
          </ul>
        </section>

        <section>
          <h2>4. שימוש מותר</h2>
          <p>אתה מתחייב להשתמש בשירות רק למטרות חוקיות ובהתאם לתנאים אלה. אסור:</p>
          <ul>
            <li>להשתמש בשירות בדרך שמפרה חוקים או תקנות</li>
            <li>להעלות תוכן פוגעני, מטעה או לא חוקי</li>
            <li>לנסות לגשת למערכות או נתונים ללא הרשאה</li>
            <li>להפריע לפעולה התקינה של השירות</li>
          </ul>
        </section>

        <section>
          <h2>5. קניין רוחני</h2>
          <p>
            כל הזכויות בשירות, כולל עיצוב, קוד, לוגו ותוכן, שייכות לכתב כמויות או לבעלי הרישיון
            שלנו. אינך רשאי להעתיק, לשנות או להפיץ חלק כלשהו מהשירות ללא אישור מפורש בכתב.
          </p>
        </section>

        <section>
          <h2>6. תוכן משתמש</h2>
          <p>
            אתה שומר על הבעלות על התוכן שאתה מעלה לשירות. עם זאת, בעצם העלאת תוכן, אתה מעניק לנו
            רישיון לאחסן, להציג ולעבד את התוכן כנדרש לצורך אספקת השירות.
          </p>
        </section>

        <section>
          <h2>7. הגבלת אחריות</h2>
          <p>
            השירות מסופק כמות שהוא (AS IS). איננו מתחייבים שהשירות יהיה זמין בכל עת, ללא שגיאות או
            מאובטח לחלוטין. לא נישא באחריות לנזקים ישירים או עקיפים הנובעים משימוש בשירות.
          </p>
        </section>

        <section>
          <h2>8. שינויים בתנאים</h2>
          <p>
            אנו שומרים לעצמנו את הזכות לעדכן תנאים אלה מעת לעת. שינויים מהותיים יפורסמו באתר ויכנסו
            לתוקף 30 יום לאחר הפרסום. המשך השימוש בשירות לאחר השינויים מהווה הסכמה לתנאים המעודכנים.
          </p>
        </section>

        <section>
          <h2>9. סיום</h2>
          <p>
            אנו רשאים להשעות או לסיים את הגישה שלך לשירות בכל עת, עם או בלי סיבה, עם או בלי הודעה
            מוקדמת. אתה רשאי לסגור את חשבונך בכל עת על ידי פנייה אלינו.
          </p>
        </section>

        <section>
          <h2>10. יצירת קשר</h2>
          <p>לשאלות בנוגע לתנאי שימוש אלה, ניתן לפנות אלינו בכתובת: support@ktav-kamuyot.co.il</p>
        </section>
      </div>
    </div>
  );
}
